







  /* eslint-disable no-console */

  import TextSelector from "@/components/TextSelector.vue";
import FormattedText from "@/components/FormattedText.vue";
import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { TextEditionDTO } from '@/dtos/sqe-dtos';

@Component({
  components: {
    TextSelector,
    FormattedText
  }
})
export default class TextViewer extends Vue {
  textObject = {} as TextEditionDTO

  @Watch('$store.state.scroll_id')
  editionIdChanged(){
    this.textObject = {} as TextEditionDTO
  }

  @Watch('$store.state.col_id')
  async colIdChange(newValue: number, oldValue: number) {
    if (oldValue !== newValue && newValue !== undefined) {
      try {
          const res = await this.$com.sqeComms?.getV1EditionsEditionIdTextFragmentsTextFragmentId(this.$store.state.scroll_id, newValue)
          this.textObject = res!
      } catch(err) {
          console.error(err)
      }
    }
  }
}
